// import Navbar from './components/Navbar'
// import Intro from './components/Intro'
// import ParticlesBackground from './components/ParticlesBackground';
import './App.scss'
import Layout from './components/Layout'
// import { Ripple } from "react-preloaders";

import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Home from './components/Home'
import About from './components/About'
import Education from './components/Education'
import Training from './components/Training'
import Portfolio from './components/Portfolio'
import Contact from './components/Contact'
import Experience from './components/Experience'
function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="education" element={<Education />} />
        <Route path="training" element={<Training />} />
        <Route path="portfolio" element={<Portfolio />} />
        <Route path="experience" element={<Experience />} />
        <Route path="contact" element={<Contact />} />

      </Route>
    </Routes>
  )
}

export default App
